/** @format */

import React from 'react';
import {
	ModalBackground,
	RightSidebarWrapper,
	NavbarWrapper,
	ContentContainer,
	FirstWrapper,
	SecondWrapper,
	UserWrapper,
	CheckProfileWrapper,
	UserAvatarContainer,
	ProfileModalWrapper
} from './styles';
import { MDIconImg } from '../styles';
import Language from '../Language';
import UserGroup from '../UserGroup';
import Close from '../../../../images/img/closed.svg';
import MenuGroup from '../Menu/MenuGroup';
import MenuItem from '../Menu/MenuItem';
import { navbarItems } from '../useNavbar';
import { Trans } from 'react-i18next';
import { useRightSidebar } from './useRightSidebar';
import { CSSTransition } from 'react-transition-group';
import ProfileModal from '../UserGroup/ProfileModal';

const RightSidebar = ({ showUserGroup }) => {
	const {
		ref,
		aud,
		url,
		closeRightSidebar,
		isOpenProfileModal,
		toggleProfileModal
	} = useRightSidebar();
	return (
		<ModalBackground>
			<RightSidebarWrapper>
				<NavbarWrapper>
					<MDIconImg
						src={Close}
						width="24"
						height="24"
						onClick={closeRightSidebar}
					/>
					<Language />
					{showUserGroup && !aud && <UserGroup type="XL" />}
					{aud && (
						<UserWrapper onClick={toggleProfileModal}>
							<CheckProfileWrapper>
								<Trans i18nKey={'profile.checkInfo'} />
							</CheckProfileWrapper>
							<UserAvatarContainer>
								<img src={url} />
							</UserAvatarContainer>
						</UserWrapper>
					)}
					<CSSTransition
						in={isOpenProfileModal} // 用於判斷是否出現的狀態
						timeout={1000} // 動畫持續時間
						classNames="profile-modal">
						<ProfileModalWrapper ref={ref}>
							{isOpenProfileModal && <ProfileModal />}
						</ProfileModalWrapper>
					</CSSTransition>
				</NavbarWrapper>
				<ContentContainer>
					{navbarItems.map((navbarItem) => {
						return (
							<MenuGroup
								key={`sidebar_${navbarItem.i18nKey}`}
								i18nKey={navbarItem.i18nKey}
								path={navbarItem.path}>
								{navbarItem.group.map((groupItem) => {
									return (
										<FirstWrapper key={`sidebar_group_${groupItem.i18nKey}`}>
											<MenuGroup
												i18nKey={groupItem.i18nKey}
												path={groupItem.path}>
												{groupItem.items.map((item) => {
													return (
														<SecondWrapper key={`sidebar_item_${item.i18nKey}`}>
															<MenuItem
																i18nKey={item.i18nKey}
																path={item.path}
															/>
														</SecondWrapper>
													);
												})}
											</MenuGroup>
										</FirstWrapper>
									);
								})}
							</MenuGroup>
						);
					})}
				</ContentContainer>
			</RightSidebarWrapper>
		</ModalBackground>
	);
};

export default React.memo(RightSidebar);
